// extracted by mini-css-extract-plugin
export default {"layout":"pj93J","layout--cut":"i3hg6","layout--default":"ktRSp","layout--half":"I0Fxc"};